import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { colFormRef } from './consts';

export default grapesjs.plugins.add('gjs-change-passowrd-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'change-password-form',
    blocks: [colFormRef],
    defaultStyle: true,
    labelColForm: 'Change Password Form',
    labelColFormCategory: 'Forms',
    labelTraitMethod: 'Method',
    labelTraitAction: 'Action',
    labelColName: 'Collection',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
});
